import React, {useState, useCallback, useEffect, useMemo} from "react";
import Banner from "../assets/images/banners/EnterToWin.jpg";
import imageMob from "../assets/images/banners/EnterToWin-mob.jpg";
import { Link, useOutletContext, useNavigate, useParams } from "react-router-dom";
import parse from "html-react-parser";
import { handleApiCall } from "../apis";
import { endpoints } from "../utils/endpoints";
import { useLanguage } from "../context/LanguageContext";
import { getLocalizedFieldValue } from "../utils/language";
import he from "he";
const buildMediaUrl = (path = "") => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const base = (process.env.REACT_APP_API || "").replace(/\/+$/, "");
  if (!base) return path;
  const normalizedBase = base.replace(/\/v1$/i, "");
  return `${normalizedBase}/${path.replace(/^\/+/, "")}`;
};

function EnterToWin() {
  const { setBannerData } = useOutletContext();
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [competitionData, setCompetitionData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [countries, setCountries] = useState([]);
  const [countryLoading, setCountriesLoading] = useState(false);
  const [privacyLink, setPrivacyLink] = useState("");

  const isCompetitionEnded = useMemo(() => {
  if (!competitionData?.end_date) return false;
    const now = new Date();
    const endDate = new Date(competitionData.end_date);

    return now > endDate;
  }, [competitionData]);

  const fetchPrivacyLink = useCallback(async () => {
  try {
    const response = await handleApiCall(
      "get",
      `${endpoints.getContent}?type=privacy_policy`
    );    
    if (response?.data?.success) {
      const data = response.data.data;

      const link =
        language === "AR"
          ? data?.description_ar || data?.description_en
          : data?.description_en || data?.description_ar;      
      setPrivacyLink(link);
    }
  } catch (error) {
    console.error("Privacy link fetch error:", error);
  }
}, [language]);

useEffect(() => {
  fetchPrivacyLink();
}, [fetchPrivacyLink]);


  // const fetchCompetitionData = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const response = await handleApiCall("get", endpoints.saudiaCompetitionList);
  //     if (
  //       response?.data?.code === 200 ||
  //       response?.data?.code === "200" ||
  //       response?.data?.success === true
  //     ) {
  //       const data = response?.data?.data;
  //       // Handle different response structures
  //       let normalized = null;
  //       if (Array.isArray(data?.competititon) && data.competititon.length > 0) {
  //         normalized = data.competititon[0];
  //       } else if (Array.isArray(data?.competition) && data.competition.length > 0) {
  //         normalized = data.competition[0];
  //       } else if (Array.isArray(data?.data) && data.data.length > 0) {
  //         normalized = data.data[0];
  //       } else if (Array.isArray(data) && data.length > 0) {
  //         normalized = data[0];
  //       } else if (data && typeof data === 'object') {
  //         normalized = data;
  //       }
  //       setCompetitionData(normalized);
  //     } else {
  //       setCompetitionData(null);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching competition data:", error);
  //     setCompetitionData(null);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);

  const { competition_id } = useParams();

const fetchCompetitionData = useCallback(async () => {  
  if (!competition_id) return;

  setLoading(true);
  try {
    const response = await handleApiCall("get", `${endpoints.saudiaCompetitionDetails}/${competition_id}`);

    if (
      response?.data?.code === 200 ||
      response?.data?.code === "200" ||
      response?.data?.success === true
    ) {
      console.log("responseresponseresponse", response.data.data);
      setCompetitionData(response?.data?.data?.competition);
    } else {
      setCompetitionData(null);
    }
  } catch (err) {
    console.error("Details fetch error:", err);
    setCompetitionData(null);
  } finally {
    setLoading(false);
  }
}, [competition_id]);


  useEffect(() => {
    fetchCompetitionData();
  }, [fetchCompetitionData]);

  // Fetch country list (with pagination support)
  const fetchCountries = useCallback(async () => {
      setCountriesLoading(true);
      try {
          let allCountries = [];
          let page = 1;
          let hasMore = true;
          
          // Fetch all pages to get complete country list
          while (hasMore) {
              const response = await handleApiCall("get", `${endpoints.countryList}?page=${page}&limit=100`);
              if (
                  response?.data?.code === 200 ||
                  response?.data?.code === "200" ||
                  response?.data?.success === true
              ) {
                  const data = response?.data?.data;
                  if (Array.isArray(data?.data)) {
                      const pageCountries = data.data.filter(country => country.status === 1);
                      allCountries = [...allCountries, ...pageCountries];
                      
                      // Check if there are more pages
                      if (data.pages && page < data.pages) {
                          page++;
                      } else {
                          hasMore = false;
                      }
                  } else {
                      hasMore = false;
                  }
              } else {
                  hasMore = false;
              }
          }
          setCountries(allCountries);
      } catch (error) {
          console.error("Error fetching countries:", error);
          setCountries([]);
      } finally {
          setCountriesLoading(false);
      }
  }, [language]);

  useEffect(() => {
  fetchCountries();
}, [fetchCountries]);


  // // Get title from API or fallback
  // const title = useMemo(() => {
  //   if (competitionData) {
  //     const titleEn = competitionData?.enter_to_win_title_en || competitionData?.enter_to_win_title_english;
  //     const titleAr = competitionData?.enter_to_win_title_ar || competitionData?.enter_to_win_title_arabic;
  //     return language === "AR" ? (titleAr || titleEn || "Lorem ipsum dolor sit amet.") : (titleEn || titleAr || "Lorem ipsum dolor sit amet.");
  //   }
  //   return "Lorem ipsum dolor sit amet.";
  // }, [competitionData, language]);

  // // Get description from API
  // const description = useMemo(() => {
  //   if (competitionData) {
  //     const desc = getLocalizedFieldValue(competitionData, language, "description") || 
  //                  getLocalizedFieldValue(competitionData, language, "enter_to_win_description") ||
  //                  "";
  //     return desc ? he.decode(desc) : "";
  //   }
  //   return "";
  // }, [competitionData, language]);


  // 1) Banner / main title
const title = useMemo(() => {
  if (!competitionData) return "";

  const en = competitionData?.title_en || competitionData?.title || "";
  const ar = competitionData?.title_ar || competitionData?.title || "";

  return language === "AR" ? ar || en : en || ar;
}, [competitionData, language]);

// 2) Enter To Win section title
const enterToWinTitle = useMemo(() => {
  if (!competitionData) return "";

  const en =
    competitionData?.enter_to_win_title_en ||
    competitionData?.enter_to_win_title ||
    "";
  const ar =
    competitionData?.enter_to_win_title_ar ||
    competitionData?.enter_to_win_title ||
    "";

  return language === "AR" ? ar || en : en || ar;
}, [competitionData, language]);

// 3) Enter To Win description
const description = useMemo(() => {
  if (!competitionData) return "";

  const en =
    competitionData?.enter_to_win_discription_en ||
    competitionData?.enter_to_win_discription_en ||
    "";
  const ar =
    competitionData?.enter_to_win_discription_ar ||
    competitionData?.enter_to_win_discription_ar ||
    "";

  const finalDesc = language === "AR" ? ar || en : en || ar;
  return finalDesc ? he.decode(finalDesc) : "";
}, [competitionData, language]);


  // Get banner images from API or fallback
  const desktopBanner = useMemo(() => {
    if (competitionData?.desktop_banner || competitionData?.desktop_image) {
      return buildMediaUrl(competitionData.desktop_banner || competitionData.desktop_image);
    }
    //return Banner;
  }, [competitionData]);

  const mobileBanner = useMemo(() => {
    if (competitionData?.mobile_banner || competitionData?.mobile_image) {
      return buildMediaUrl(competitionData.mobile_banner || competitionData.mobile_image);
    }
    //return imageMob;
  }, [competitionData]);

  useEffect(() => {
    setBannerData({
      image: desktopBanner,
      MobileBanner: mobileBanner,
      title: title,
      subtitle: "",
      skew: false,
      bannershow: true,
      titleClass: "text-[30px] md:text-[4rem] leading-tight text-white font-SaudiaBold !hidden"
    });
  }, [setBannerData, desktopBanner, mobileBanner, title]);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    country: "",
    ageRange: "",
    // terms: false,
    // marketing: false,
    competition_id : "",
    terms_and_conditions: false,
    opt_in: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = language === "AR" ? "الاسم الأول مطلوب" : "First name is required";
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = language === "AR" ? "اسم العائلة مطلوب" : "Last name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = language === "AR" ? "البريد الإلكتروني مطلوب" : "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = language === "AR" ? "البريد الإلكتروني غير صحيح" : "Invalid email format";
    }

    if (!formData.country) {
      newErrors.country = language === "AR" ? "البلد مطلوب" : "Country is required";
    }

    if (!formData.ageRange) {
      newErrors.ageRange = language === "AR" ? "الفئة العمرية مطلوبة" : "Age range is required";
    }

    if (!formData.terms_and_conditions) {
      newErrors.terms_and_conditions = language === "AR" ? "يجب الموافقة على الشروط والأحكام" : "You must accept the terms and conditions";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isCompetitionEnded) {
      return;
    }
    
    if (!validateForm()) {
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        country: formData.country,
        age_range: formData.ageRange,
        competition_id : competition_id,
        terms_and_conditions: formData.terms_and_conditions || false,
        opt_in: formData.opt_in || false,
      };

      const response = await handleApiCall("post", endpoints.addWinForm, payload);
      
      if (
        response?.data?.code === 200 ||
        response?.data?.code === "200" ||
        response?.data?.success === true
      ) {
        // Get the form ID from response
        const formId = response?.data?.data?._id;
        if (formId) {
          // Redirect to survey page with form ID as query parameter
          // navigate(`/enter-to-win-survey?formId=${formId}`);
          navigate(`/enter-to-win-survey?formId=${formId}&competition_id=${competition_id}`);
        } else {
          setErrors({
            submit: language === "AR" ? "لم يتم الحصول على معرف النموذج" : "Form ID not received",
          });
        }
      } else {
        setErrors({
          submit: response?.data?.message || (language === "AR" ? "حدث خطأ أثناء الإرسال" : "An error occurred while submitting"),
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrors({
        submit: error?.response?.data?.message || (language === "AR" ? "حدث خطأ أثناء الإرسال" : "An error occurred while submitting"),
      });
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <> 
      <div className="container max-w-8xl mx-auto px-2 py-8 md:py-0 md:px-8 2xl:px-32 grid grid-cols-12">
        <div className="mb-10 md:mb-20 gap-x-16 col-span-12 md:col-span-8 text-white">
          <h2 className="text-3xl md:text-[2.625rem] font-SaudiaRegular mb-4 md:my-10">
            {enterToWinTitle}
          </h2>
          {loading ? (
            <p className="text-white/90 mb-10 text-lg font-SaudiaLight">
              {language === "AR" ? "جاري التحميل..." : "Loading..."}
            </p>
          ) : description ? (
            // <div className="text-white/90 mb-10 text-lg font-SaudiaLight">
            //   {parse(description)}
            // </div>
            <div
              className="
                text-white/90 mb-10 text-lg font-SaudiaLight
                prose prose-invert max-w-none
                [&_p]:mb-4
                [&_p:empty]:h-4
                [&_p:empty]:block
                [&_br]:block
              "
            >
              {parse(description)}
            </div>
          ) : (
            <p className="text-white/90 mb-10 text-lg font-SaudiaLight">
              {language === "AR" ? "لا توجد بيانات متاحة حالياً." : "No data available at the moment."}
            </p>
          )}
          <form onSubmit={handleSubmit} className="[&_label]:font-SaudiaRegular [&_label]:text-[17px] [&_label]:mb-1 [&_label]:flex">
            <div className="block mb-6">
              <label className="text-sm font-medium">{language === "AR" ? "الاسم الأول" : "First name"}</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                className={`mt-1 w-full px-3 py-2 rounded bg-transparent border autofillGreen font-SaudiaRegular h-10 text-sm ${errors.firstName ? "border-red-500" : "border-white"} focus:outline-none placeholder:text-white/30`}
                placeholder={language === "AR" ? "الاسم الأول" : "First name"}
                onChange={handleChange}
              />
              {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
            </div>
            <div className="block mb-6">
              <label className="text-sm font-medium">{language === "AR" ? "اسم العائلة" : "Last name"}</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                className={`mt-1 w-full px-3 py-2 rounded bg-transparent border autofillGreen font-SaudiaRegular h-10 text-sm ${errors.lastName ? "border-red-500" : "border-white"} focus:outline-none placeholder:text-white/30`}
                placeholder={language === "AR" ? "اسم العائلة" : "Last name"}
                onChange={handleChange}
              />
              {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
            </div>
            <div className="block mb-6">
              <label className="text-sm font-medium">{language === "AR" ? "البريد الإلكتروني" : "Email address"}</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                className={`mt-1 w-full px-3 py-2 rounded bg-transparent border autofillGreen font-SaudiaRegular h-10 text-sm ${errors.email ? "border-red-500" : "border-white"} focus:outline-none placeholder:text-white/30`}
                placeholder={language === "AR" ? "البريد الإلكتروني" : "Email address"}
                onChange={handleChange}
              />
              {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
            </div>
            <div className="block mb-6">
              <label className="text-sm font-medium">{language === "AR" ? "بلد الإقامة" : "Country of residence"}</label>
              <select
                name="country"
                value={formData.country}
                className={`mt-1 w-full p-2 rounded 
                  bg-transparent text-white 
                  font-SaudiaRegular
                  h-10
                  text-sm
                  border ${errors.country ? "border-red-500" : "border-white"}
                  focus:outline-none
                  [&>option]:text-black
                  [&>option]:bg-white
                `}
                // className={`mt-1 w-full p-2 rounded bg-transparent border autofillGreen ${errors.country ? "border-red-500" : "border-white"} focus:outline-none placeholder:text-white/30`}
                onChange={handleChange}
              >
                {/* <option value="">{language === "AR" ? "اختر..." : "Select…"}</option>
                <option value="Saudi Arabia">Saudi Arabia</option>
                <option value="United States">United States</option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="UAE">UAE</option> */}
                  <option value="" className="text-black">
                      {countryLoading 
                          ? (language === "AR" ? "جاري التحميل..." : "Loading...") 
                          : (language === "AR" ? "اختر..." : "Select…")
                      }
                  </option>
                  {countries.map((country) => {
                    const countryName = language === "AR" 
                        ? (country.name_ar || country.name_en) 
                        : (country.name_en || country.name_ar);
                    return (
                        <option key={country._id} value={countryName} className="text-black">
                            {countryName}
                        </option>
                    );
                  })}

              </select>
              {errors.country && <p className="text-red-500 text-sm mt-1">{errors.country}</p>}
            </div>
            <div className="block mb-6">
              <label className="text-sm font-medium">{language === "AR" ? "الفئة العمرية" : "Age range"}</label>
              <select
                name="ageRange"
                value={formData.ageRange}
                className={`mt-1 w-full p-2 rounded 
                  bg-transparent text-white 
                  font-SaudiaRegular
                  h-10
                  text-sm
                  border ${errors.ageRange ? "border-red-500" : "border-white"}
                  focus:outline-none
                  [&>option]:text-black
                  [&>option]:bg-white
                `}
                // className={`mt-1 w-full p-2 rounded bg-transparent border ${errors.ageRange ? "border-red-500" : "border-white"} focus:outline-none placeholder:text-white/30`}
                onChange={handleChange}
              >
                <option value="">{language === "AR" ? "اختر..." : "Select…"}</option>
                <option value="18-24">18-24</option>
                <option value="25-34">25-34</option>
                <option value="35-44">35-44</option>
                <option value="45-54">45-54</option>
                <option value="55-64">55-64</option>
                <option value="65+">65+</option>
              </select>
              {errors.ageRange && <p className="text-red-500 text-sm mt-1">{errors.ageRange}</p>}
            </div>
            <div className="flex items-start gap-3 mb-4 [&_label]:text-sm font-SaudiaRegular">
              <input
                type="checkbox"
                name="terms_and_conditions"
                checked={formData.terms_and_conditions}
                onChange={handleChange}
                className="mt-1"
              />
              {/* <label>
                {language === "AR" ? (
                  <>أبلغ من العمر على الأقل 18 عامًا، وأوافق على شروط وأحكام السحب، وقد قرأت إشعار الخصوصية للخطوط السعودية.</>
                ) : (
                  <>I am at least 18 years old, agree to the prize draw Terms & Conditions, and have read the Saudia Privacy Notice.</>
                )}
              </label> */}
              <label className="!font-SaudiaRegular text-xs !block">
  {language === "AR" ? (
    <>
      أبلغ من العمر على الأقل 18 عامًا، وأوافق على{" "}
      <Link
        to="/terms-and-conditions"
        target="_blank"
        className="underline cursor-pointer text-green-500"
      >
        شروط وأحكام السحب
      </Link>
      ، وقد قرأت{" "}
      <Link
        to={privacyLink || "#"}
        target="_blank"
        className="underline cursor-pointer text-green-500"
      >
        إشعار الخصوصية
      </Link>
      .
    </>
  ) : (
    <>
      I am at least 18 years old, agree to the prize draw{" "}
      <Link
        to="/terms-and-conditions"
        target="_blank"
        className="underline cursor-pointer text-green-500"
      >
        Terms & Conditions
      </Link>
      , and have read the Saudia{" "}
      <Link
        to={privacyLink || "#"}
        target="_blank"
        className="underline cursor-pointer text-green-500"
      >
        Privacy Notice
      </Link>
      .
    </>
  )}
</label>

            </div>
            {errors.terms_and_conditions && <p className="text-red-500 text-sm mb-4 -mt-2">{errors.terms_and_conditions}</p>}
            <div className="flex items-start gap-3 mb-6 [&_label]:text-sm font-SaudiaRegular">
              <input
                type="checkbox"
                name="opt_in"
                checked={formData.opt_in}
                onChange={handleChange}
                className="mt-1"
              />
              <label>
                {language === "AR" ? (
                  <>بالتأشير على المربع التالي، أوافق على استخدام الخطوط السعودية لمعلوماتي لإبقائي على اطلاع بأحدث العروض الخاصة والأخبار عبر البريد الإلكتروني، وسائل التواصل الاجتماعي، الفيديو الرقمي، والإعلانات المرئية. أفهم أن لدي الحق في إلغاء الاشتراك أو تحديث تفضيلاتي في أي وقت عن طريق التواصل مع الخطوط السعودية (راجع سياسة الخصوصية) أو باتباع تعليمات إلغاء الاشتراك في التواصل ذات الصلة بالشركة.</>
                ) : (
                  <>By ticking the following box, I consent to Saudia using my information to keep me up to date with the latest special offers and news via email, social media, digital video and display advertising. I understand I have the right to unsubscribe or update my preferences at any time by contacting Saudia (see Privacy Policy) or by following the unsubscribe instructions on company's relevant communication.</>
                )}
              </label>
            </div>
            {errors.submit && <p className="text-red-500 text-sm mb-4">{errors.submit}</p>}
            <div className="flex justify-start items-start">
              {/* <button
                type="submit"
                disabled={submitting}
                className="bg-black text-white py-2 rounded-lg hover:bg-gray-950 transition px-16 text-lg font-SaudiaRegular disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {submitting ? (language === "AR" ? "جاري الإرسال..." : "Submitting...") : (language === "AR" ? "اشترك الآن" : "Enter now")}
              </button> */}
              <button
                type="submit"
                disabled={submitting || isCompetitionEnded}
                className="bg-black text-white py-2 rounded-lg hover:bg-gray-950 transition px-16 text-lg font-SaudiaRegular disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isCompetitionEnded
                  ? (language === "AR" ? "المسابقة مغلقة" : "Competition Closed")
                  : submitting
                  ? (language === "AR" ? "جاري الإرسال..." : "Submitting...")
                  : (language === "AR" ? "اشترك الآن" : "Enter now")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default EnterToWin;
